import { render, staticRenderFns } from "./UnknownLoanTypeList.vue?vue&type=template&id=72eda0fa&scoped=true&"
import script from "./UnknownLoanTypeList.vue?vue&type=script&lang=js&"
export * from "./UnknownLoanTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eda0fa",
  null
  
)

export default component.exports